import { Theme } from "@mui/material"
import { ACTIONS } from "app/store/actions"
import { Action } from "redux"
import { IUIConfiguration, IUIConfigurationTranslations } from "ui/configuration/model"
import { IColorPickerPopupParams, IMenuItem } from "ui/model"

export interface IActionSetSidePanelVisible extends Action {
  visible: boolean
}

export interface IActionSetSidePanelBasemapSectionOpened extends Action {
  visible: boolean
}

export interface IActionSetTheme extends Action {
  theme: Theme
  config: IUIConfiguration
}

interface IActionSetContainerSizeParams {
  width?: number
  height?: number
}

export interface IActionSetMenus extends Action {
  menus: IMenuItem[]
}

export interface IActionSetContainerSize extends IActionSetContainerSizeParams, Action {
  // nothing to add
}

export interface IActionSetMenuSize extends Action {
  isOpened: boolean
}

export interface IActionSetIsSavingConfig extends Action {
  isSaving: boolean
}

export interface IActionOpenColorPickerPopup extends Action, IColorPickerPopupParams {
  // nothing to add
}

export interface IActionSetTempUiConfig extends Action {
  uiConfig: IUIConfiguration
}

export interface IActionSetUiConfigUndoRedoState extends Action {
  newUiConfig: IUIConfiguration
  history: IUIConfiguration[]
  index: number
}

export interface IActionSetIsDarkPreview extends Action {
  isDarkPreview: boolean
}

export interface IActionSetUiConfigTranslations extends Action {
  translations: IUIConfigurationTranslations
}

export const uiActionCreator = {
  reset(): Action {
    return {
      type: ACTIONS.APP_UI_RESET_STATE
    }
  },
  setTheme(theme: Theme, config: IUIConfiguration): IActionSetTheme {
    return {
      type: ACTIONS.APP_UI_SET_THEME,
      theme,
      config
    }
  },
  setContainerSize(params: IActionSetContainerSizeParams): IActionSetContainerSize {
    return {
      type: ACTIONS.APP_UI_SET_CONTAINER_SIZE,
      ...params
    }
  },
  setMenuSize(isOpened: boolean): IActionSetMenuSize {
    return {
      type: ACTIONS.APP_UI_SET_MENU_SIZE,
      isOpened
    }
  },
  setMenus(menus: IMenuItem[]): IActionSetMenus {
    return {
      type: ACTIONS.APP_UI_SET_MENUS,
      menus
    }
  },
  openColorPickerPopup(params: IColorPickerPopupParams): IActionOpenColorPickerPopup {
    return {
      type: ACTIONS.APP_UI_OPEN_COLOR_PICKER_POPUP,
      ...params
    }
  },
  closeColorPickerPopup(): Action {
    return {
      type: ACTIONS.APP_UI_CLOSE_COLOR_PICKER_POPUP
    }
  },
  setIsSavingConfig(isSaving: boolean): IActionSetIsSavingConfig {
    return {
      type: ACTIONS.APP_UI_SET_IS_SAVING_CONFIG,
      isSaving
    }
  },
  setTempUiConfig(uiConfig: IUIConfiguration): IActionSetTempUiConfig {
    return {
      type: ACTIONS.APP_UI_SET_TEMP_UI_CONFIG,
      uiConfig
    }
  },
  setUiConfigTranslations(translations: IUIConfigurationTranslations): IActionSetUiConfigTranslations {
    return {
      type: ACTIONS.APP_UI_SET_UI_CONFIG_TRANSLATIONS,
      translations
    }
  },
  setUiConfigUndoRedoState(
    newUiConfig: IUIConfiguration,
    history: IUIConfiguration[],
    index: number
  ): IActionSetUiConfigUndoRedoState {
    return {
      type: ACTIONS.APP_UI_SET_UNDO_REDO_UI_CONFIG_STATE,
      newUiConfig,
      history,
      index
    }
  },
  setIsDarkPreview(isDarkPreview: boolean): IActionSetIsDarkPreview {
    return {
      type: ACTIONS.APP_UI_SET_IS_DARK_PREVIEW,
      isDarkPreview
    }
  }
}
